import { FlowStepEditor } from "../FlowStepEditor";
import { FormEditUI } from "./FormEditUI";
import { FormStep } from "../../../rule-engine-core/Flow/Steps/UI/FormStep";
import { FormConfiguration } from "../../../Form/FormConfiguration";

export class FormStepEditor extends FlowStepEditor<FormStep> {
    renderEditUI(): JSX.Element | null {
        let form = new FormConfiguration();
        if (this.stepData.formData) form.setStorageData(this.stepData.formData);
        return (
            <FormEditUI
                stepData={this.stepData}
                form={form}
                onSave={(executableConf: FormConfiguration) => {
                    this.stepData.formData = executableConf.getStorageData();
                    this.stepData.outcomePaths = executableConf.getOutcomes();
                }}
                onClose={() => {}}
                name={this.name}
                onFormNameUpdate={(executableName: string) => {
                    this.name = executableName;
                    this.stepUpdate();
                }}
            />
        );
    }
}
